import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CollectionDocument } from '../../../interfaces/collection.interface';

@Component({
  selector: 'app-view-document-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-document-modal.component.html',
  styleUrl: './view-document-modal.component.css'
})
export class ViewDocumentModalComponent {
  @Input() collectionName!: string;
  @Input() document!: CollectionDocument;
  @Output() close = new EventEmitter<void>();
  sourcesWords: string[] = [];

  constructor(public activeModal: NgbActiveModal) {}

  onClose(): void {
    this.activeModal.dismiss();
  }

  getSummaryText(): string {
    return this.document?.summary?.trim() || '';
  }

  getDocumentSources(): string[] {
    if (!this.document.summary) return [];
    const sources: string[] = [];
    const lines = this.document.summary.split('\n').filter((line: string) => line.trim().length > 0);
    sources.push(...lines.slice(0, 8));
    return sources;
  }

  getKeywords(){
    this.sourcesWords = this.document?.Sources || [];
    const uniqueWords = [...new Set(this.sourcesWords)];
    return uniqueWords;
  }
 
}